export function EmptyScreenView({ navigation }) {
    return null;
}
